import { Component } from '@angular/core';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';

@Component({
  selector: 'app-modal-data-procesing-agreement-not-confirmed-info',
  templateUrl: './modal-data-procesing-agreement-not-confirmed-info.component.html',
  styleUrl: './modal-data-procesing-agreement-not-confirmed-info.component.scss'
})
export class ModalDataProcessingAgreementNotConfirmedInfoComponent  extends ModalDialogV3 {

}

